import { useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer';
import { CardShapeDb } from '../redux/cardShapeDbSlice';

const useCardShapeDbs = (cardId: string | undefined): [string[], CardShapeDb[]] => {
  const cardShapeDb = useSelector((state: RootState) => state.cardShapeDb);
  const ids = Object.keys(cardShapeDb.cardShapes).filter(id => cardShapeDb.cardShapes[id].cardId === cardId);
  ids.sort((a, b) => {
    const aValue = cardShapeDb.cardShapes[a];
    const bValue = cardShapeDb.cardShapes[b];
    return bValue.z - aValue.z;
  })
  const values = ids.map(id => cardShapeDb.cardShapes[id]);

  return [ids, values];
}

export default useCardShapeDbs;
